import axios from '@/libraries/axios/main';
import ApiResponseOld from '@/interfaces/ApiResponseOld';
import CountItemPayload from '@/models/payloads/CountItem';

export async function getEntities(payload: CountItemPayload[]): Promise<ApiResponseOld> {
  const response = await axios
    .post(
      '/count'
      , {
        entities: payload,
      },
    );

  return response.data as ApiResponseOld;
}
